import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "lucide-react";
import { thoughts, thoughtMeta } from "../../data/thoughts";
import { H2, H3 } from "../../utils/typography";
type RelatedThoughtsProps = {
  slugs: string[];
  /** Empty slots shown until more related thoughts exist */
  placeholderCount?: number;
};
export function RelatedThoughts({
  slugs,
  placeholderCount = 1
}: RelatedThoughtsProps) {
  const related = slugs.map(slug => thoughts.find(t => t.slug === slug)).filter((t): t is NonNullable<typeof t> => Boolean(t));
  return <section aria-labelledby="related-thoughts-heading" data-id="element-133" data-mp="19vqa6cb4ab8p">
      <div className="flex items-end justify-between gap-6" data-id="element-134" data-mp="19x9t6ao5r0e6">
        <h2 id="related-thoughts-heading" className={`${H2} text-espresso`} data-id="element-135" data-mp="1evl46oq6vgxz">
          Related thoughts
        </h2>
        <Link to="/thoughts" className="text-sm font-medium uppercase tracking-wide text-espresso/70 transition-colors duration-150 hover:text-rust" data-id="element-136" data-mp="10wv553jt776z">
          All thoughts
        </Link>
      </div>

      <ul className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8" data-id="element-137" data-mp="1ydou5wtbhalk">
        {related.map(t => <li key={t.slug} data-id="element-138" data-mp="2cdpwlgp8cq35">
            <Link to={`/thoughts/${t.slug}`} className="group flex h-full flex-col rounded-3xl bg-espresso p-8 md:p-10" data-id="element-139" data-mp="2cbvd86tlx616">
              <p className="text-sm font-medium uppercase tracking-wide text-mustard" data-id="element-140" data-mp="1jnzgx37y9g4x">{t.category}</p>
              <h3 className={`mt-4 ${H3} text-cream`} data-id="element-141" data-mp="1epxy8jefritz">
                {t.title}
              </h3>
              <div className="mt-auto flex items-center justify-between gap-4 pt-10" data-id="element-142" data-mp="1teu5ie8o4rtj">
                <span className="text-sm text-cream/50" data-id="element-143" data-mp="1onvmh6wapfml">{thoughtMeta(t)}</span>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-rust text-cream transition-colors duration-150 group-hover:bg-mustard group-hover:text-espresso" data-id="element-144" data-mp="1olsmbu1fi645">
                  <ArrowUpRightIcon className="h-4 w-4" data-id="element-145" data-mp="vwu0alu6qjtk" />
                </span>
              </div>
            </Link>
          </li>)}
        {Array.from({
        length: placeholderCount
      }).map((_, i) => <li key={`placeholder-${i}`} className="flex min-h-[14rem] flex-col justify-between rounded-3xl border border-dashed border-espresso/20 p-8 md:p-10" data-id="element-146" data-mp="30xxunfuqkiyq" data-mpi={i}>
            <p className="text-sm font-medium uppercase tracking-wide text-espresso/70" data-id="element-147" data-mp="39uf6klaxckvj">Still thinking</p>
            <p className="text-espresso/70" data-id="element-148" data-mp="2d4o9ceb90jm1">More on this when I’ve worked through the questions.</p>
          </li>)}
      </ul>
    </section>;
}